const doc = [({"da":({"js":({"admin":({"invoices":({"link":({"invoice_no":"#%{invoice_no}", "invoice_id":"ID%{invoice_id}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;